import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full border border-primary-200 dark:border-primary-800 bg-white dark:bg-primary-950 px-4 py-3 text-base font-light text-primary-950 dark:text-white transition-colors duration-300 file:border-0 file:bg-transparent file:text-sm file:font-light placeholder:text-primary-400 focus-visible:outline-none focus-visible:border-primary-400 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
